import React from 'react';
import { st, classes } from './TextSubscriptionName.st.css';

export const TextSubscriptionName: React.FC = ({ children }) => (
  <span className={st(classes.root, {})}>{children}</span>
);
